module.exports = __webpack_public_path__ + "cb74e3e94501ea4d80625e7aeda3387d.pdf";